/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VendorStatisticsResponse { 
    offerSalesPending?: number | null;
    offerSalesAchieved?: number | null;
    salesOpportunitiesCount?: number | null;
    productsCount?: number | null;
    ordersPendingCount?: number | null;
    contractsDraftCount?: number | null;
    contractsExpiringCount?: number | null;
    supplyIncidentsPendingCount?: number | null;
    secondMarketPendingCount?: number | null;
    companyMembersCount?: number | null;
    companyClassesCount?: number | null;
}

